exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabela_compacta_vue td {\n\t\tfont-size: 12px !important;\n\t\tpadding-bottom: 2px !important;\n\t\tpadding-top: 2px !important;\n\t\tvertical-align: middle !important;\n\t\tborder: 1px solid #ddd;\n\t\tpadding: 8px;\n    \tline-height: 1.42857143;\n}\n", ""]);

// exports
